<template>
  <div class="index">
    <div @click="gotoGame" class="index-game"></div>
    <div class="index-rule" @click="gotoRule">活动说明≫</div>
  </div>
</template>
<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {};
  },
  methods: {
    ...mapActions('goto', ['gotoRule', 'gotoGame']),
  },
};
</script>
<style lang="scss" scoped>
.index {
  background: url(~@this/assets/image-02.jpg) #cd1110 no-repeat;
  background-size: 750px 1205px;
  width: 750px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  .index-game {
    background: url(~@this/assets/image-01.png) no-repeat;
    background-size: 100% 100%;
    width: 444px;
    height: 122px;
    margin-top: 950px;
  }
  .index-rule {
    color: #ff9593;
    margin: 30px 0;
  }
}
</style>
